import { render, staticRenderFns } from "./technical-requirements.vue?vue&type=template&id=b5565a58"
import script from "./technical-requirements.vue?vue&type=script&lang=js"
export * from "./technical-requirements.vue?vue&type=script&lang=js"
import style0 from "./technical-requirements.vue?vue&type=style&index=0&id=b5565a58&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports